import { LessonProblem, StudentProblemResult } from '@yandex-int/k-common/typings';

export enum RESULT_TABLE_CELL_TYPE {
    CARD = 'card',
    COUNTER = 'counter',
    NAME = 'name',
    PROBLEM = 'problem',
    OVERALL = 'overall',
    SCROLL_CONTROL = 'scroll-control',
    CERTIFICATE = 'certificate',
    STICKERS = 'stickers',
}

export interface CriteriaStats {
    correct: number;
    incorrect: number;
    max: number;
}

export interface CellDisplayParams {
    isOpenAnswer?: boolean;
    isRobot?: boolean;
    hasPaste?: boolean;
    criteriaStats?: CriteriaStats;
}

export interface CurrentCellData {
    problemNumber: number;
    studentId: number;
    problemId: number;
    displayParams?: CellDisplayParams;
}

export interface StudentsResult {
    studentId: number;
    studentName: string;
    result: {
        problems: Record<number, StudentProblemResult>;
        overall: {
            seenPercent: number;
            correctPercent: number;
            time: number;
            points: number;
            maxPoints: number;
        };
    };
}

export enum PROBLEM_CELL_THEME {
    PASTED = 'pasted',
    CLEAR = 'clear',
    COMPLETED = 'completed',
    ONE_ATTEMPT = 'one-attempt',
    THREE_ATTEMPTS = 'three-attempts',
    CORRECT = 'correct',
    INCORRECT = 'incorrect',
    ANSWERED = 'answered',
    OPEN_ANSWER = 'open-answer',
}

export type StudentId = number;
export type ProblemId = number | null;

export interface LessonResultsStore {
    shouldShowAttempts: boolean;
    shouldShowTime: boolean;
    shouldShowPoints: boolean;
    shouldShowDescriptionPopup: boolean;
    cellDescriptionData: CurrentCellData | null;
    isStatsExpanded: boolean;
    studentsOnline: Record<StudentId, ProblemId>;
}

export enum SWITCH_TYPE {
    TIME = 'time',
    ATTEMPTS = 'attempts',
    POINTS = 'points',
}

export interface SwitchYmParams {
    type: SWITCH_TYPE;
    time?: boolean;
    attempts?: boolean;
    points?: boolean;
}

export interface DictationMarkerSpecificData {
    orfo_mistakes: number;
    punct_mistakes: number;
    typos: number;
}

export interface AdditionalResultCellParams {
    isOpenAnswer?: boolean;
    isRobot: boolean;
    hasPaste?: boolean;
}

export type StudentProblemLinkGetter = (studentId: number, columnIndex: number) => LessonProblem | null;
